import React, { Fragment } from 'react';
import { Switch, Route } from 'react-router-dom';

import { withPathValidation } from './HOCs/withPathValidation';
import { useStyles } from './styles';
import ScrollToTop from './ScrollToTop';
import HomePage from '../HomePage';
import CategoryPage from '../_CategoryPage/CategoryPage';
import ProductsPage from '../ProductsPage';
import ErrorPage from '../ErrorPage';
import Footer from '../../components/Footer';
import LinkRedirect from '../LinkRedirectPage/LinkRedirect';

const App = () => {
	const classes = useStyles();
	const ValidatedProductsPage = withPathValidation(ProductsPage);
	const ValidatedProductPageAfterWdValidation = withPathValidation(ProductsPage);
	const ValidatedCategoryPage = withPathValidation(CategoryPage);

	return (
		<Fragment>
			<ScrollToTop />

			<main className={classes.main}>
				<Switch>
					<Route exact path="/" render={() => <HomePage />} />
					<Route exact path="/error" render={() => <ErrorPage />} />
					<Route exact path="/linksRedirect" render={() => <LinkRedirect />} />
					<Route
						exact
						path="/:categorylevel1/:categorylevel2?/:categorylevel3?/products/:filters?"
						render={() => <ValidatedProductsPage />}
					/>
					<Route
						exact
						path="/:categorylevel1/:categorylevel2?/:categorylevel3?/products/wdValidated"
						render={() => <ValidatedProductPageAfterWdValidation />}
					/>
					<Route
						exact
						path="/:categorylevel1/:categorylevel2?/:categorylevel3?"
						render={() => <ValidatedCategoryPage />}
					/>
					<Route render={() => <ErrorPage message="pageNotFound" />} />
				</Switch>
			</main>

			<Route path="/" render={({ location }) => location.pathname !== '/' && <Footer />} />
		</Fragment>
	);
};

export default App;
